import { cx } from '@apparel/react/cx';
import { CartService } from '@apparel/ui/cart';
import { Image } from '@apparel/ui/images/Image';
import { CustomDesignButton } from '@apparel/ui/productCard/CustomDesignButton';
import { CustomizableWheel as CustomWheel } from '@apparel/ui/productCard/CustomizableWheel';
import { formatPrice } from '@apparel/ui/productCard/ProductCard';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import { transparentize } from 'polished';
import styled from 'styled-components';
import { GoogleTagService } from '../../lib/GoogleTag';
import { GTag } from '../../lib/utils';
import { YotpoStars } from '../../lib/YotpoStars';
import { getSubdomainData } from '@lib/utils';
const isMobile = window.innerWidth <= 599;

const useStyles = makeStyles((theme) => {
    const primary = theme.palette?.primary?.main || '#e4002b';

    return {
    box: {
        width: '100%',
        minWidth: '231px',
        display: 'inline-flex',
        padding: '7px 12px 7px 3px',

        [theme.breakpoints.down('xs')]: {
            padding: '7px 7px 4px 3px',
        },
    },
    selected: {
        border: `4px solid ${primary} !important`,

        '&:hover': {
            boxShadow: `0 0 0 0 !important`,
            borderColor: `${primary} !important`,
        },
    },
    checked: {
        zIndex: 5,
        top: '14px',
        right: '16px',
        color: primary,
        position: 'absolute',
        fontSize: '28px !important',

        [theme.breakpoints.down('xs')]: {
            fontSize: '24px !important',
        },
    },
    productCard: {
        width: '100%',
        height: '313px',
        display: 'flex',
        minWidth: '232px',
        cursor: 'pointer',
        overflow: 'hidden',
        borderRadius: '8px',
        position: 'relative',
        wordWrap: 'break-word',
        flexDirection: 'column',
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.87)',
        backgroundClip: 'border-box',
        border: '1px solid lightgray',
        textDecoration: 'none !important',
        transition: 'box-shadow 250ms ease-out, border-color 250ms ease-out',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            height: '120px',
            borderRadius: '4px',
            flexDirection: 'row',
        },

        '& *': {
            textDecoration: 'none !important',
        },

        '&:hover': {
            borderColor: transparentize(0.25, primary),
            boxShadow: `0 0 0 3px ${transparentize(0.5, primary)}`,

            '&:hover $layer': {
                opacity: 1,
                pointerEvents: 'all',

                '& button': {
                    opacity: 1,
                    transform: 'translate3d(0, 0, 0)',
                },
            },
        },
    },
    productCardBody: {
        display: 'flex',
        padding: '14px 12px',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '12px 10px',
            justifyContent: 'space-between',
            borderLeft: '1px solid lightgray',
        },
    },
    productCardTitle: {
        margin: 0,
        fontWeight: 500,
        fontSize: '12px',
        textAlign: 'left',
        lineHeight: '14px',
        marginBottom: '6px',
        letterSpacing: '0.21px',
        color: 'rgba(0, 0, 0, 0.87)',
        fontFamily: "'Roboto', sans-serif",

        [theme.breakpoints.down('xs')]: {
            marginBottom: '2px',
            width: 'calc( 100% - 24px )',
        },
    },
    minPrice: {
        margin: 0,
        opacity: 1,
        display: 'flex',
        fontWeight: 500,
        fontSize: '16px',
        color: '#e4002b',
        lineHeight: '16px',
        marginRight: '4px',
        fontFamily: 'Roboto',
        alignItems: 'center',
        alignContent: 'center',
        letterSpacing: '0.24px',
    },
    priceInfo: {
        opacity: 1,
        display: 'flex',
        fontWeight: 400,
        fontSize: '14px',
        flexWrap: 'wrap',
        lineHeight: '20px',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        alignItems: 'center',
        letterSpacing: '0.24px',
        justifyContent: 'start',
        color: 'rgba(0, 0, 0, 0.54)',
        fontFamily: "'Roboto', sans-serif",

        '& span, small, b': {
            whiteSpace: 'nowrap',
        },

        '& small': {
            fontWeight: 400,
            fontSize: '11px',
            lineHeight: '14px',
            fontFamily: 'Roboto',
            letterSpacing: '0.21px',

            '&:first-child': {
                marginLeft: 0,
                marginRight: '2px',
            },
        },

        '& b': {
            color: 'rgba(0, 0, 0, 0.84)',
        },
    },
    layer: {
        zIndex: 99,
        opacity: 0,
        top: '-2px',
        left: '-2px',
        right: '-2px',
        bottom: '-2px',
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        pointerEvents: 'none',
        alignContent: 'center',
        justifyContent: 'center',
        transition: 'opacity 250ms',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    addToCartButton: {
        opacity: 0,
        transitionDelay: '150ms',
        transform: 'translate3d(0, 14px, 0)',
        transition: 'opacity 250ms, transform 400ms',

        [theme.breakpoints.down('xs')]: {
            width: '90%',
            fontSize: '10px',
        },
    },
    priceSection: {
        marginTop: '14px',
    },
    productImageHolder: {
        width: '100%',
        padding: '8px',
        height: '192px',
        display: 'flex',
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: '#fff',
        borderBottom: '1px solid #eee',

        [theme.breakpoints.down('xs')]: {
            width: '50%',
            padding: '0',
            height: '118px',
            borderBottom: '0px solid #eee',
        },

        '& p': {
            top: '50%',
            left: '50%',
            margin: '0',
            fontSize: '14px',
            fontWeight: 400,
            position: 'absolute',
            textTransform: 'uppercase',
            transform: 'translate(-50%, -50%)',
            color: 'transparentize(#000, 0.36)',
        },
    },
    };
});

const ProductImage = ({ product, isDr }) => {
    const classes = useStyles({});
    const isPackage = product.is_package;

    const addToCart = (e) => {
        e.preventDefault();
        const id = product.id;
        const cart = CartService.getInstance();
        GoogleTagService.reportConversion(GTag.Add_to_cart);
        const quantity = Math.max(product.minimum_order_quantity, 1);

        isPackage
            ? cart.addPackage({
                  id: parseInt(id),
                  quantity: quantity,
                  model_type: 'package',
                  category_id: product?.category_id,
                  subcategories: product?.subcategories,
              })
            : cart.addItem({
                  model_type: 'sku',
                  quantity: quantity,
                  sku_id: parseInt(id),
                  model_id: parseInt(id),
                  category_id: product?.category_id,
                  subcategory_id: product?.subcategory_id,
              });

        cart.emitOpenCart();
    };

    return (
        <div className={classes.productImageHolder}>
            <Image
                source={product?.image}
                alt={product?.image_alt ?? product?.name}
                objectFit={'contain'}
                objectPosition={'center'}
            />

            {!isDr ? (
                <div className={classes.layer}>
                    {product?.is_sizing_kit ? (
                        <Button
                            variant={'contained'}
                            color={'primary'}
                            onClick={addToCart}
                            className={classes.addToCartButton}
                        >
                            Add to Cart
                        </Button>
                    ) : (
                        <CustomDesignButton
                            modelId={product?.id}
                            name={'Get a free design'}
                            categoryId={product?.category_id}
                            isSizingKit={product?.is_sizing_kit}
                            packageItems={product?.subcategories}
                            subcategoryId={product?.subcategory_id}
                            categoryName={product['categories.lvl0'][0]}
                            minimumOrder={product?.minimum_order_quantity}
                            modelType={product?.is_package ? 'package' : 'sku'}
                        />
                    )}
                </div>
            ) : null}
        </div>
    );
};

export const ProductBody = ({ product }) => {
    const classes = useStyles({});
    const wholesalerBySubdomain = getSubdomainData();
    const minOrder = product?.minimum_order_quantity ? product?.minimum_order_quantity : 1;
    const maxPrice = formatPrice(product?.price?.max?.price || product?.price_range?.highest || 0);
    const minPrice = formatPrice(product?.price?.min?.price || product?.price_range?.lowest || 0);
    const price10to25 = formatPrice(product?.price_range?.['10_25'] ?? 0);

    /*useEffect(() => {
        setTimeout(function () {
            if (typeof window['yotpo'] !== 'undefined') {
                window['yotpo'].initWidgets();
            }
        }, 3000);
    }, []);*/

    return (
        <div className={cx('card-body', classes.productCardBody)}>
            <h3 className={cx('card-title', classes.productCardTitle)} title={product?.name}>
                <b>{product?.name}</b>
            </h3>
            {YotpoStars(product)}
            <section className={classes.priceSection}>
                <div style={{ marginBottom: '5px' }} className={classes.priceInfo}>
                    <p className={classes.minPrice}>{wholesalerBySubdomain?.id ? price10to25 : minPrice} </p>
                    {!wholesalerBySubdomain?.id && (
                        <small className={'text-mute ml-0'}>{`(1,000+)`}</small>
                    )}
                </div>
                <div className={classes.priceInfo}>
                    <small className={'text-mute ml-0'}>{`Min. Quantity: ${minOrder}`}</small>
                    <small className={'text-mute ml-0'}>{`(${maxPrice}/Piece)`}</small>
                </div>
            </section>
        </div>
    );
};

export function ProductCard(props) {
    const { product, isDr, handleClick, selected } = props;
    const classes = useStyles(props);

    const children = (
        <>
            {!isMobile ? (
                <CustomPlaceholder>
                    <CustomWheel />
                </CustomPlaceholder>
            ) : null}
            <ProductImage product={product} isDr={isDr} />
            <ProductBody product={product} />
        </>
    );

    return (
        <Box className={classes.box} key={product.id} p={1} marginRight={isDr ? '20px' : ''}>
            {isDr ? (
                <div
                    className={selected ? cx(classes.selected, classes.productCard) : classes.productCard}
                    role={'none'}
                    onClick={handleClick}
                >
                    {selected ? (
                        <Icon className={classes.checked}>check_circle</Icon>
                    ) : (
                        <AddCircleOutlineRoundedIcon className={classes.checked} />
                    )}
                    {children}
                </div>
            ) : (
                <a href={product?.url} className={classes.productCard}>
                    {children}
                </a>
            )}
        </Box>
    );
}

export const CustomPlaceholder = styled.div`
    position: absolute;
    top: 9px;
    left: 9px;
    z-index: 5;
`;

export default ProductCard;
export const ApparelProductCard = ProductCard;
